import { Observable } from 'rxjs';
import { parse } from 'query-string';
import { replace } from 'react-router-redux';

import { STORE as STORE_USER } from 'entities/user/constants';
import OrganizationsApi from 'entities/organization/api';
import { selectOrganization } from 'entities/user/selectors';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import { initSuccessAction, initFailedAction } from './actions';
import { INIT } from './constants';
import { selectInitialized } from './selectors';

const init = (action$, store) =>
  action$.ofType(INIT, STORE_USER).mergeMap(({ type, query }) => {
    if (!query) {
      return [replace('/donations')];
    }

    const state = store.getState();
    if (type === STORE_USER && !selectInitialized(state)) {
      return [];
    }

    const organization = selectOrganization(state);
    const destination = `/donations${organization && organization.isCompany() ? '/rules' : ''}`;

    const queryParameters = parse(query);
    if (queryParameters.error || queryParameters.error_description) {
      return [showErrorAction(queryParameters.error_description), replace(destination)];
    }

    return OrganizationsApi.authorizeStripe({
      scope: queryParameters.scope,
      code: queryParameters.code,
    })
      .mergeMap((resultingAction) => [
        resultingAction,
        showMessageAction('Connected with Stripe succesfully!'),
        initSuccessAction(),
        replace(destination),
      ])
      .catch((e) =>
        Observable.of(
          initFailedAction(e),
          showErrorAction('Connecting with Stripe failed.'),
          replace(destination)
        )
      );
  });

export default [init];
